import React, { useEffect } from "react";
import { Card } from "react-bootstrap";
import { NavLink, useParams } from "react-router-dom";
import { subscriptionPlanServices } from "../../APIServices/Editor/subscriptionPlanServices";

const SuccessPayment = () => {
  let { uniqueId } = useParams();

  const confirmSubscriptionPaymentStatus = async () => {
    let userData = {
      uniqueId: uniqueId,
    };
    await subscriptionPlanServices.confirmSubscriptionPaymentStatus(userData);
  };

  useEffect(() => {
    confirmSubscriptionPaymentStatus();
  }, []);
  return (
    <>
      <div
        className="paymentSucess hstack justify-content-center"
        style={{ height: "100vh" }}
      >
        <Card style={{ width: "18rem" }}>
          <Card.Body className="text-center">
            <Card.Title>
              <b>Payment Successfull</b>
            </Card.Title>
            <div className="circle my-4">
              <div className="checkmark hstack">✓</div>
            </div>
            <Card.Text className="mb-2">
              Thanks! Your Payment has been Successfully Completed.
            </Card.Text>
            <div className="button_type">
              <NavLink to="/home" >
                <button>Go to Home Page</button>
              </NavLink>
            </div>
          </Card.Body>
        </Card>
      </div>
    </>
  );
};

export default SuccessPayment;
